import React, {useEffect, useState} from "react";
import {postRaw} from "../../utils/communication";
import {getCookie, hashPassword, setCookie} from "../../utils/crypto";
import {Link, useNavigate} from "react-router-dom";
import nanoid from "../../utils/nanoid";

function Register() {
    let [loading, setLoading] = useState(true),
        [posting, setPosting] = useState(false),
        [formData, setFormData] = useState({
            name: '',
            email: '',
            password: '',
            code: ''
        }),
        [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Register - Hoarfroster";

        const fetchState = async () => {
            let state = await fetchLoginState();

            if (state) {
                navigate("/");
            } else {
                setLoading(false);
            }
        };

        let _ = fetchState();
    }, []);

    const fetchLoginState = async (): Promise<boolean> => {
        const token = getCookie("token");
        if (!token || token === "") {
            return false;
        }

        let response = await postRaw("/user/sign-in?authorize=header", {}, {"Authorization": token});
        return response.code === 200;
    }

    const handleInputChange = (event: { target: { name: any; value: any; }; }) => {
        const {name, value} = event.target;
        setFormData({...formData, [name]: value});
    };

    const onSubmit = async (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        setPosting(true);
        let response = await postRaw("/user/register", {
            publicId: nanoid(),
            name: formData.name,
            email: formData.email,
            password: await hashPassword(formData.password),
            code: formData.code
        });

        if (response.code === 200) {
            setCookie("token", response.data["token"], response.data["maxAge"]);
            navigate("/");
        } else {
            setPosting(false);
            setError(response.data.error);
        }
    }

    const buildForm = () => {
        return (
            <form onSubmit={onSubmit} className="form-sm">
                <h1 className="text-center">Register</h1>

                <div className="labeled-input">
                    <div className="label-group">
                        <label htmlFor="name"
                               className="label">Username</label>
                    </div>
                    <input type="text"
                           id="name"
                           name="name"
                           value={formData.name}
                           required
                           onChange={handleInputChange}
                           className="input"
                           placeholder="Username"/>
                </div>

                <div className="labeled-input">
                    <div className="label-group">
                        <label htmlFor="name"
                               className="label">Email</label>
                    </div>
                    <input type="text"
                           id="email"
                           name="email"
                           value={formData.email}
                           required
                           onChange={handleInputChange}
                           className="input"
                           placeholder="Email"/>
                </div>

                <div className="labeled-input">
                    <div className="label-group">
                        <label htmlFor="password"
                               className="label">
                            Password
                        </label>
                        <div className="action">Forgot Password?</div>
                    </div>
                    <input type="password"
                           id="password"
                           name="password"
                           value={formData.password}
                           required
                           onChange={handleInputChange}
                           className="input"
                           placeholder="Password"/>
                </div>

                <div className="labeled-input">
                    <div className="label-group">
                        <label htmlFor="password"
                               className="label">
                            Code
                        </label>
                        <div className="action">How can I get one?</div>
                    </div>
                    <input type="text"
                           id="code"
                           name="code"
                           value={formData.code}
                           onChange={handleInputChange}
                           className="input"
                           placeholder="Password"/>
                </div>

                <div className="actions">
                    <button type="submit" className="button" disabled={posting}>
                        {posting ? "Register" : "Registering"}
                    </button>
                </div>

                <p className="form-tips">
                    By registering to the website, you agree with our <Link to="/user/eula">end user
                    license agreement(EULA)</Link>.
                </p>

                <div className="separator">
                    <div className="left"></div>
                    <div className="center">Or continue with</div>
                    <div className="right"></div>
                </div>

                <p className="form-tips">
                    Got an account already?
                    <Link to="/user/register">Signing in to Hoarfroster.</Link>
                </p>
            </form>
        );
    }

    return (
        <main>
            <div className="container">
                <div className="content">
                    {loading ? <p>Loading...</p> : buildForm()}
                </div>

                <div className="sidebar">
                    <h2>Welcome to Hoarfroster!</h2>
                    <p className="text-4">Please register to continue.</p>
                </div>
            </div>
        </main>
    );
}

export default Register;